import { createActions } from 'redux-actions';

import { UpdateUserMobileNumberParams } from '@apis/UserMobileNumberApi';

export type State = {
  isSuccess: boolean;
  serverErrors: object;
};

export type UpdateMobileNumberPayload = UpdateUserMobileNumberParams;
export type StateUpdatePayload = Partial<State>;

export const {
  mobileNumberUpdate,
  stateUpdate,
} = createActions(
  'MOBILE_NUMBER_UPDATE',
  'STATE_UPDATE',
  {
    prefix: 'MOBILE_NUMBER',
  },
);
